import React from "react";
import { Phone, Mail, MapPin, Clock, CreditCard } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F2E52] text-[#F0F7E8]">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-[#0F2E52] text-white grid place-items-center font-bold text-lg">
              PT
            </div>
            <div className="font-[Work_Sans] font-bold text-xl">The Patient Tech Bloke</div>
          </div>
          <p className="mt-4 text-base md:text-lg text-[#CBD5E1] leading-relaxed">
            Friendly, patient IT help for seniors — at home, by phone, or remotely.
            Honest pricing and no jargon.
          </p>
        </div>

        <div>
          <h4 className="font-[Work_Sans] font-semibold text-lg text-white">Get in touch</h4>
          <ul className="mt-4 space-y-3 text-base md:text-lg">
            <li className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-[#0F2E52]" />
              <a href={`tel:${SITE.phoneTel}`} className="link-underline" data-testid="footer-phone">{SITE.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-[#0F2E52]" />
              <a href={`mailto:${SITE.email}`} className="link-underline break-all" data-testid="footer-email">{SITE.email}</a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="w-5 h-5 text-[#0F2E52]" />
              <span>{SITE.area}</span>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="w-5 h-5 text-[#0F2E52]" />
              <span>{SITE.hours}</span>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-payment">
              <CreditCard className="w-5 h-5 text-[#6BAF3C]" />
              <span><strong className="text-white">EFTPOS or Cash</strong> on completion</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-[Work_Sans] font-semibold text-lg text-white">Quick links</h4>
          <ul className="mt-4 space-y-3 text-base md:text-lg">
            <li><a href="#services" className="link-underline" data-testid="footer-link-services">Services</a></li>
            <li><Link to="/pricing" className="link-underline" data-testid="footer-link-pricing">Pricing</Link></li>
            <li><a href="#scam-help" className="link-underline" data-testid="footer-link-scam">Scam Help</a></li>
            <li><a href="#about" className="link-underline" data-testid="footer-link-about">About</a></li>
            <li><a href="#faq" className="link-underline" data-testid="footer-link-faq">FAQs</a></li>
            <li><a href="#book" className="link-underline" data-testid="footer-link-book">Book a Visit</a></li>
            <li><Link to="/privacy-policy" className="link-underline" data-testid="footer-link-privacy">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-6 text-sm md:text-base text-[#CBD5E1] flex flex-col sm:flex-row gap-2 justify-between items-start sm:items-center">
          <span>© {new Date().getFullYear()} The Patient Tech Bloke · ABN 96 584 230 274</span>
          <Link to="/privacy-policy" className="link-underline" data-testid="footer-bottom-privacy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}
